import React, { useRef } from "react";
import { Routes, Route } from "react-router-dom"; 
import Header from "./header/page";
import MainPage from "./mainpage";

function App() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Header 
        scrollHome={() => scrollToSection(homeRef)}
        scrollAbout={() => scrollToSection(aboutRef)}
        scrollServices={() => scrollToSection(servicesRef)}
        scrollContact={() => scrollToSection(contactRef)}
      /> 

      <div>
        <Routes>
          <Route 
            path="/" 
            element={
              <MainPage 
                homeRef={homeRef} 
                aboutRef={aboutRef} 
                servicesRef={servicesRef} 
                contactRef={contactRef} 
              />
            } 
          />
          <Route 
            path="/home" 
            element={
              <MainPage 
                homeRef={homeRef} 
                aboutRef={aboutRef} 
                servicesRef={servicesRef} 
                contactRef={contactRef} 
              />
            } 
          />
        </Routes>
      </div>
    </>
  );
}

export default App;
